import customaxios from "../index";

export const getPreneedProfileDetails = () => {
  return customaxios({
    method: "GET",
    url: "/planner-dashboard/profile",
  });
};

export const createPreneedProfile = (data: any) => {
  return customaxios({
    method: "POST",
    url: "/planner-dashboard/profile",
    data,
  });
};

export const updatePreneedProfile = (data: any) => {
  return customaxios({
    method: "PUT",
    url: "/planner-dashboard/profile",
    data,
  });
};

export const uploadPreneedPhoto = (data: FormData) => {
  return customaxios({
    method: "POST",
    url: "/planner-dashboard/profile/photo",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deletePreneedPhoto = () => {
  return customaxios({
    method: "DELETE",
    url: "/planner-dashboard/profile/photo",
  });
};

export const preneedChangePassword = (data: URLSearchParams) => {
  return customaxios({
    method: "POST",
    url: "/auth/planner/change-password",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
export const searchPartner = ({
  type,
  value,
}: {
  type: string;
  value: string;
}) => {
  return customaxios({
    method: "GET",
    url: `/planner-dashboard/profile/crm-partner/search`,
    params: {
      type,
      value,
    },
  });
};
export const linkPartnerToPlanner = (
  id: any,
  crmPartner: {
    id: number;
    companyName: string;
    email: string;
    phoneNumber: string;
  },
) => {
  return customaxios({
    method: "POST",
    url: `/planner-dashboard/profile/crm-partner/link/${id}`,
    data: {
      crmPartner: crmPartner,
    },
  });
};
